"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * The Jira Cloud platform REST API
 * Jira Cloud platform REST API documentation
 *
 * The version of the OpenAPI document: 1001.0.0-SNAPSHOT-1df5db7255b44a0b9aa806f0b2de7cddb4bbffc9
 * Contact: ecosystem@atlassian.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MigrationResourceUpdateEntityPropertiesValuePutEntityTypeEnum = exports.AppMigrationApi = void 0;
const tslib_1 = require("tslib");
const runtime = require("../runtime");
const index_1 = require("../models/index");
/**
 *
 */
class AppMigrationApi extends runtime.BaseAPI {
    /**
     * Updates the value of a custom field added by Connect apps on one or more issues. The values of up to 200 custom fields can be updated.  **[Permissions](#permissions) required:** Only Connect apps can make this request
     * Bulk update custom field value
     */
    appIssueFieldValueUpdateResourceUpdateIssueFieldsPutRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (requestParameters['atlassianTransferId'] == null) {
                throw new runtime.RequiredError('atlassianTransferId', 'Required parameter "atlassianTransferId" was null or undefined when calling appIssueFieldValueUpdateResourceUpdateIssueFieldsPut().');
            }
            if (requestParameters['connectCustomFieldValues'] == null) {
                throw new runtime.RequiredError('connectCustomFieldValues', 'Required parameter "connectCustomFieldValues" was null or undefined when calling appIssueFieldValueUpdateResourceUpdateIssueFieldsPut().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (requestParameters['atlassianTransferId'] != null) {
                headerParameters['Atlassian-Transfer-Id'] = String(requestParameters['atlassianTransferId']);
            }
            const response = yield this.request({
                path: `/rest/atlassian-connect/1/migration/field`,
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.ConnectCustomFieldValuesToJSON)(requestParameters['connectCustomFieldValues']),
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * Updates the value of a custom field added by Connect apps on one or more issues. The values of up to 200 custom fields can be updated.  **[Permissions](#permissions) required:** Only Connect apps can make this request
     * Bulk update custom field value
     */
    appIssueFieldValueUpdateResourceUpdateIssueFieldsPut(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.appIssueFieldValueUpdateResourceUpdateIssueFieldsPutRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Updates the values of multiple entity properties for an object, up to 50 updates per request. This operation is for use by Connect apps during app migration.
     * Bulk update entity properties
     */
    migrationResourceUpdateEntityPropertiesValuePutRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (requestParameters['atlassianTransferId'] == null) {
                throw new runtime.RequiredError('atlassianTransferId', 'Required parameter "atlassianTransferId" was null or undefined when calling migrationResourceUpdateEntityPropertiesValuePut().');
            }
            if (requestParameters['entityType'] == null) {
                throw new runtime.RequiredError('entityType', 'Required parameter "entityType" was null or undefined when calling migrationResourceUpdateEntityPropertiesValuePut().');
            }
            if (requestParameters['entityPropertyDetails'] == null) {
                throw new runtime.RequiredError('entityPropertyDetails', 'Required parameter "entityPropertyDetails" was null or undefined when calling migrationResourceUpdateEntityPropertiesValuePut().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (requestParameters['atlassianTransferId'] != null) {
                headerParameters['Atlassian-Transfer-Id'] = String(requestParameters['atlassianTransferId']);
            }
            const response = yield this.request({
                path: `/rest/atlassian-connect/1/migration/properties/{entityType}`.replace(`{${"entityType"}}`, encodeURIComponent(String(requestParameters['entityType']))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: requestParameters['entityPropertyDetails'].map(index_1.EntityPropertyDetailsToJSON),
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Updates the values of multiple entity properties for an object, up to 50 updates per request. This operation is for use by Connect apps during app migration.
     * Bulk update entity properties
     */
    migrationResourceUpdateEntityPropertiesValuePut(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.migrationResourceUpdateEntityPropertiesValuePutRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Returns configurations for workflow transition rules migrated from server to cloud and owned by the calling Connect app.
     * Get workflow transition rule configurations
     */
    migrationResourceWorkflowRuleSearchPostRaw(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (requestParameters['atlassianTransferId'] == null) {
                throw new runtime.RequiredError('atlassianTransferId', 'Required parameter "atlassianTransferId" was null or undefined when calling migrationResourceWorkflowRuleSearchPost().');
            }
            if (requestParameters['workflowRulesSearch'] == null) {
                throw new runtime.RequiredError('workflowRulesSearch', 'Required parameter "workflowRulesSearch" was null or undefined when calling migrationResourceWorkflowRuleSearchPost().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (requestParameters['atlassianTransferId'] != null) {
                headerParameters['Atlassian-Transfer-Id'] = String(requestParameters['atlassianTransferId']);
            }
            const response = yield this.request({
                path: `/rest/atlassian-connect/1/migration/workflow/rule/search`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: (0, index_1.WorkflowRulesSearchToJSON)(requestParameters['workflowRulesSearch']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => (0, index_1.WorkflowRulesSearchDetailsFromJSON)(jsonValue));
        });
    }
    /**
     * Returns configurations for workflow transition rules migrated from server to cloud and owned by the calling Connect app.
     * Get workflow transition rule configurations
     */
    migrationResourceWorkflowRuleSearchPost(requestParameters, initOverrides) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.migrationResourceWorkflowRuleSearchPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
exports.AppMigrationApi = AppMigrationApi;
/**
 * @export
 */
exports.MigrationResourceUpdateEntityPropertiesValuePutEntityTypeEnum = {
    IssueProperty: 'IssueProperty',
    CommentProperty: 'CommentProperty',
    DashboardItemProperty: 'DashboardItemProperty',
    IssueTypeProperty: 'IssueTypeProperty',
    ProjectProperty: 'ProjectProperty',
    UserProperty: 'UserProperty',
    WorklogProperty: 'WorklogProperty',
    BoardProperty: 'BoardProperty',
    SprintProperty: 'SprintProperty'
};
//# sourceMappingURL=AppMigrationApi.js.map